import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import immutableToJS from 'helpers/immutableToJS';
import {
  HeaderTitle,
  Helper,
  injectIntl,
  Paper,
  ScrollToTop,
} from 'components';
import StoreCard from './components/StoreCard';
import { selectState } from 'redux/selectors';

class Store extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isFarmer: PropTypes.bool,
    isMember: PropTypes.bool,
  };

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    buyers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
  };

  state = {
    expanded: false,
  };

  componentWillMount() {
    this._isMounted = true;
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({ expanded: true });
      }
    }, 500);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { currentUser, isFarmer, isMember } = this.context;
    const { formatMessage, buyers } = this.props;
    const { expanded } = this.state;
    const { email, profile } = currentUser.account;
    profile.email = email;
    profile.id = -1;
    const isNoPermissionMember = buyers.filter(buyer =>
      buyer.isDeleted === true &&
      buyer.buyerProfile.email === currentUser.organizations[0].account.email);
    const isAllowedToUpdate = !(isNoPermissionMember && isNoPermissionMember.length > 0);
    return (
      <div className="store-page">
        <HeaderTitle>
          {isFarmer ? formatMessage('Store') : formatMessage('Catalog')}
        </HeaderTitle>
        <Helper name="store" />
        <Paper indicator noPadding>
          <StoreCard
            expanded={expanded}
            imageEditable={!isMember}
            info={profile}
            initialExpand
            isCatalog={!isFarmer}
            noPadding
            isAllowedToUpdate={isAllowedToUpdate}
            setExpanded={(id, callback) => callback()}
          />
        </Paper>
        <ScrollToTop invisibleHeight={400} />
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('buyers', 'buyers')(state, 'buyers'),
});

export default compose(
  setDisplayName('Store'),
  connect(
    mapStateToProps,
    null,
  ),
  immutableToJS,
  injectIntl,
)(Store);
